import React, { Component } from 'react'
import { withTranslation } from "react-i18next";
import { AssembliesService, ClientService, LocalStorageService } from '../../../services';
import CustomizationView from '../../views/customization/customization.view';
import moment from 'moment';
import { arrNoRepetElements } from '../../../utils';

class CustomizationAction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            clientLogo: {},
            clientLogoUrl: "",
            preferences: [],
            updatedPreferences: [],
            modifiedByUser: "",
            modifiedDate: "",

            showLoadingRequesting: false,
            showWarningRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            groups: [],
            companies: [],
        };
    }

    token = {};
    timezone = "";
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    clientService = new ClientService(this.url);

    toggleLoadingScreen = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleWarningRequesting = (value, message) => {
        this.setState(
            {
                showWarningRequesting: value,
                messageError: message,
            },
            () => {
                setTimeout(() => {
                    this.setState({ showWarningRequesting: false, message: "" });
                }, 5000);
            }
        );
    };

    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        });
    }

    onImageUpload = (event, key) => {
        if (event.target.files && event.target.files[0]) {
            let type = event.target.files[0].type.split('/')

            if (type[0] === 'image' && event.target.files[0].type !== 'image/tiff') {
                let reader = new FileReader()

                reader.onload = (e) => {
                    let im = new Image()
                    im.src = e.target.result
                    im.onload = () => {
                        this.setState({
                            [key]: {
                                base64: e.target.result,
                                file: event.target.files[0]
                            }
                        })
                    }
                }
                reader.readAsDataURL(event.target.files[0])
                reader = null
            } else {
                this.toggleWarningRequesting(true, "Por favor selecciona una imagen válida para continuar (png, jpg, jpeg).");
            }
        }
    }

    onImageDelete = (key) => {
        this.setState({
            [key]: {},
        })
    }

    sendClientImage = async () => {
        let data = new FormData();
        data.append("image", this.state.clientLogo.file);
        return await this.clientService.sendClientImage(this.token, data);
    }

    getClientImage = async () => {
        let result = await this.clientService.getClientImage(this.token);
        if (result.statusCode == 200) {
            if (result?.data?.image) {
                this.localStorageService.setLocalStorageItem('clientLogo', result.data.image)
                this.setState({
                    clientLogoUrl: result.data.image,
                });
            } else {
                this.localStorageService.setLocalStorageItem('clientLogo', '')
            }
        } else {
            throw new Error("Ocurrió un error al obtener tu logo y preferencias")
        }
    }

    assemblyCompanies = async () => {
        try {
            let companiesAssemblies = await AssembliesService.getCompaniesAssemblies(this.token)
            if (companiesAssemblies.statusCode !== 200) throw new Error("Ocurrió un error al obtener tus preferencias")

            this.setState({ companies: companiesAssemblies.data })
        } catch (e) {
            this.toggleLoadingRequesting(false);
            this.toggleErrorRequesting(true, e.message, 4000)
        }
    }

    formatPreferences = (data, setGroups) => {
        let preferences = [];

        for (let pref of data) {
            if (pref.preferenceId === 0) {
                this.setState({
                    modifiedByUser: pref.updatedByUser,
                    modifiedDate: pref.updatedDate
                });
                continue;
            };

            let current = { ...pref }

            if (current.preferenceName === process.env.REACT_APP_PREFERENCE_DOCUMENT_TO_OCR) {
                current.configRule = current.configRule.map(item => {
                    return {
                        name: this.props.t(`customizationView.preferences.options.${item.name}`),
                        key: item.key
                    }
                })
            }

            current.preferenceName = this.props.t(`customizationView.preferences.name.${current.preferenceName}`)
            if (current.preferenceName === process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP && !current.numberValue) {
                current.numberValue = +process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP_DEFAULT_VALUE
            }

            if (current.preferenceName === process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP && !current.numberValue) {
                current.numberValue = +process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP_DEFAULT_VALUE
            }

            if (current.preferenceName === this.props.t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes') && !current.numberValue) {
                current.numberValue = Number(process.env.REACT_APP_PREFERENCE_SESSION_INACTIVITY_TIMEOUT_DEFAULT_VALUE)
            }

            current.booleanValue = (pref.booleanValue != "" && pref.booleanValue) || pref.stringValue != "" || pref.numberValue != "" || pref.dateValue != "";

            if (current.preferenceName === process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP || current.preferenceName === process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP) {
                current.booleanValue = true
            }

            current.extraData = {}

            if (current.type === "custom_file") {
                current.extraData["companyId"] = this.state.companies[0]?.id
            }

            current.help = current.help ? this.props.t(`customizationView.preferences.help.${current.help}`) : null
            preferences.push(current)
        }

        let groups = []
        if (setGroups) {
            let dataGroups = []
            data.map((preference) => {
                if (preference.group) dataGroups.push(preference.group)
            })
            dataGroups = arrNoRepetElements(dataGroups)
            // dataGroups.push(this.props.t("customizationView.groups.others"))
            dataGroups = dataGroups.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            let groupsFilter = dataGroups.map((group) => {
                let info = {
                    name: this.props.t(`customizationView.preferences.title.${group}`),
                    key: group
                }

                return info
            })

            groups = groupsFilter.map((group) => {
                let conditional = (group === this.props.t("customizationView.groups.others")) ? null : group.key
                let preferencesGroup = preferences.filter(preference => preference.group === conditional)
                preferencesGroup = preferencesGroup.sort((a, b) => a.preferenceName.toLowerCase().localeCompare(b.preferenceName.toLowerCase()))
                let dataGroup = {
                    group: group.name,
                    preferences: preferencesGroup
                }
                return dataGroup
            })
        }
        this.setState({
            preferences,
            updatedPreferences: [...preferences],
            groups
        });
    }

    getPreferecesData = async () => {
        let result = await this.clientService.getClientPreferences(this.token, this.timezone);
        if (result.statusCode == 200) {
            let data = result.data;
            this.formatPreferences(data, true);
        } else {
            throw new Error("Ocurrió un error al obtener tus preferencias")
        }
    }

    setPreferences = (preferences) => {
        this.setState({
            updatedPreferences: preferences
        });
    }

    setGroups = (groups) => {
        this.setState({
            groups
        })
    }

    onSavePreferences = async () => {
        this.toggleLoadingRequesting(true);
        try {
            let prefData = [];
            let prefFiles = [];
            let ENV = process.env
            let prefIsFooter = false
            let prefFooterValue = false

            let updatedPreferences = [...this.state.updatedPreferences];
            for (let pref of updatedPreferences) {
                pref = {
                    ...JSON.parse(JSON.stringify(pref)),
                    stringValue: pref.stringValue
                }
                let og = this.state.preferences.find(og => og.preferenceId == pref.preferenceId);
                if (pref.preferenceName === this.props.t("customizationView.preferences.name.nameProcessignDocumentsForEntityExtractionWithAI") && !pref.stringValue) {
                    pref.stringValue = this.props.t("customizationView.preferences.options.userChoose")
                    pref.booleanValue = true
                }
                if (og.stringValue == pref.stringValue && og.numberValue == pref.numberValue && og.dateValue == pref.dateValue && og.booleanValue == pref.booleanValue) continue; // skip unchanged preferences

                let value = "";

                if (pref.type == "string") value = pref.stringValue;
                if (pref.type == "number") value = pref.numberValue;
                if (pref.type == "date") value = pref.dateValue;
                if (pref.type == 'file') value = typeof pref.stringValue == "string" ? pref.stringValue : pref.stringValue.name;
                if (pref.type == "selector") {
                    value = pref.stringValue;
                    pref.booleanValue = true
                    if (pref.preferenceName === this.props.t("customizationView.preferences.name.nameProcessignDocumentsForEntityExtractionWithAI")) {
                        if (pref.stringValue === this.props.t("customizationView.preferences.options.disabled")) value = 'disabled'
                        if (pref.stringValue === this.props.t("customizationView.preferences.options.userChoose")) value = 'userChoose'
                        if (pref.stringValue === this.props.t("customizationView.preferences.options.processAllDocuments")) value = 'processAllDocuments'
                    }
                }
                if (pref.type == 'custom_file') value = typeof pref.stringValue == "string" ? pref.stringValue : pref.stringValue.name;

                if (pref.type == "boolean") {
                    value = pref.booleanValue === true;
                } else {
                    if (pref.booleanValue && value == "") { // checked but without input
                        this.toggleLoadingRequesting(false);
                        this.toggleWarningRequesting(true, "Debes llenar todos los campos que seleccionaste.");
                        return;
                    }
                }

                if (pref.type == "file" && pref.booleanValue) {
                    prefFiles.push({
                        id: pref.preferenceId,
                        file: pref.stringValue
                    })
                }

                if (pref.type == "custom_file" && pref.booleanValue) {
                    prefFiles.push({
                        id: pref.preferenceId,
                        file: pref.stringValue
                    })
                }

                if (pref.preferenceName === ENV.REACT_APP_PREFERENCE_FOOTER) {
                    prefIsFooter = true
                    prefFooterValue = pref.booleanValue
                }

                prefData.push({
                    id: pref.preferenceId,
                    active: pref.booleanValue,
                    extraData: pref.extraData,
                    value
                });
            }

            if (this.state.clientLogo.base64) {
                let responseImage = await this.sendClientImage();
                if (responseImage.statusCode != 200) {
                    throw new Error("Ocurrió un error al guardar el logo y tus preferencias.")
                } else {
                    this.localStorageService.setLocalStorageItem('clientLogo', responseImage.data.image);
                    this.setState({
                        clientLogoUrl: responseImage.data.image,
                    });
                }
            }

            if (prefData.length) {
                let response = await this.clientService.saveClientPreferences(this.token, this.timezone, prefData, prefFiles);
                if (response.statusCode === 200) {
                    if (prefIsFooter) this.localStorageService.setLocalStorageItem("footerEnabled", prefFooterValue)
                    let user = this.localStorageService.getLocalStorageItem("user");
                    this.setState({
                        modifiedDate: moment(new Date()).format("DD-MMM-YYYY"),
                        modifiedByUser: user.userMetaData.userMifirma.email,
                    });
                    this.formatPreferences(response.data, true);
                } else {
                    throw new Error("Ocurrió un error al guardar tus preferencias.")
                }
            }

            this.toggleCompletedRequesting(true)
            this.toggleLoadingRequesting(false);
            setTimeout(() => {
                this.toggleCompletedRequesting(false)
            }, 4000)
        } catch (e) {
            this.toggleLoadingRequesting(false);
            this.toggleErrorRequesting(true, e.message, 4000)
        }
    }

    async componentDidMount() {
        this.toggleLoadingScreen(true);
        try {
            this.timezone = this.localStorageService.getLocalStorageItem("timezone");
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            await this.getClientImage();
            await this.assemblyCompanies()
            await this.getPreferecesData();
            this.toggleLoadingScreen(false);
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    render() {
        return (
            <CustomizationView
                {...this.state}
                onImageUpload={this.onImageUpload}
                onImageDelete={this.onImageDelete}
                setPreferences={this.setPreferences}
                onSavePreferences={this.onSavePreferences}
                setGroups={this.setGroups}

                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleWarningRequesting={this.toggleWarningRequesting}
            />
        )
    }
}

export default withTranslation()(CustomizationAction)